import { render, staticRenderFns } from "./examinerBi.vue?vue&type=template&id=47b0552d&"
import script from "./examinerBi.vue?vue&type=script&lang=js&"
export * from "./examinerBi.vue?vue&type=script&lang=js&"
import style0 from "./examinerBi.vue?vue&type=style&index=0&id=47b0552d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports